// /dashboard/:orgSlug/terms/:termId — Figma frame 13 term detail (33:455).
// Owner: screens-analytics, US-112. Walkthrough beats 6 and 7.
//
// `doc` is a search param and not an optional nicety. A `term_id` is doc-local
// in every seeded and fixture document — `t04` names a different term in each
// one — so the leaderboard row that navigates here passes the document it was
// ranked under, and the detail then agrees with it number for number. Both
// params come out of the URL, which is what makes a pasted link render the same
// screen as a click.

import { createRoute } from "@tanstack/react-router";
import { shellRoute } from "./_shell";
import { TermDetailScreen } from "../screens/analytics/TermDetailScreen";
import {
  DEFAULT_RANGE,
  isRangeDays,
  type RangeDays,
} from "../screens/analytics/RangeChips";

type TermSearch = { doc?: string; days: RangeDays };

export const termDetailRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: "/dashboard/$orgSlug/terms/$termId",
  staticData: { title: "Term detail" },
  validateSearch: (search: Record<string, unknown>): TermSearch => {
    const raw = Number(search.days);
    return {
      doc: typeof search.doc === "string" && search.doc ? search.doc : undefined,
      days: isRangeDays(raw) ? raw : DEFAULT_RANGE,
    };
  },
  component: TermDetailRoute,
});

function TermDetailRoute() {
  const { orgSlug, termId } = termDetailRoute.useParams();
  const { doc, days } = termDetailRoute.useSearch();

  return (
    <TermDetailScreen
      orgSlug={orgSlug}
      termId={termId}
      docId={doc}
      days={days}
    />
  );
}
